import React, { FC } from 'react'

export const TrainingDataDescription: FC = () => {
  return (
    <>
      Please paste list of test cases separated by new lines you want to test against all NLP
      models. Every test case is triplet of utterance, modelId and intentId separated by tab
      character. For example you can copy this format from any spreadsheet editor, such as:
      <br />
      <br />
      <pre>
        <table className="custom-modal-table-padding">
          <tr>
            <td>
              <strong>utterance</strong>
            </td>
            <td>
              <strong>modelId</strong>
            </td>
            <td>
              <strong>intentId</strong>
            </td>
          </tr>
          <tr>
            <td>how are you?</td>
            <td>chitchat</td>
            <td>how-are-you</td>
          </tr>
          <tr>
            <td>your name?</td>
            <td>chitchat</td>
            <td>user-name</td>
          </tr>
        </table>
      </pre>
      Also you can use two-column format with model ID and intent ID in the same value separated by
      the "---" sequence.
    </>
  )
}
